import { render, staticRenderFns } from "./editFilmDistributor.vue?vue&type=template&id=1d9751c5&"
import script from "./editFilmDistributor.vue?vue&type=script&lang=js&"
export * from "./editFilmDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports